import React, { useState } from 'react'
import MainLayout from '../Layouts/MainLayout'
import FollowUpsSearch from './FollowUpsSearch'

function FollowUpsSearchContainer() {
  const [navParams, setNavParams] = useState({
    navTitle: "User Search",
    navSubTitle: "Welcome to ImagesBazaar"
})
const [addUserModal, setAddUserModal] = useState(false)
const handleAddUserModal = (value=false) =>{
  setAddUserModal(value)
}

const handleNavParams = (obj)=>{
  setNavParams({
      ...navParams,
      ...obj
  })
}
  return (
    <MainLayout navTitle={navParams.navTitle} navSubTitle={navParams.navSubTitle}>
      <FollowUpsSearch handleNavParams={handleNavParams} />
    </MainLayout>
  )
}

export default FollowUpsSearchContainer;